export const ego_0_bente_win = [
  'Ok, Boomer.',
  'Dein Ego hat 0 LP. BenteBot siegt.',
];
